// Хелперы новостей, безопасные для клиента (без server-only импортов).
// Хештеги и SEO — по языкам, с фолбэком на старые общие поля (совместимость).
import type { Locale } from "./locale-utils";
import type { NewsItem } from "./fleet-server"; // только тип (стирается при сборке)

export function newsTags(n: NewsItem, locale: Locale): string[] {
  const perLang = locale === "en" ? n.tags_en : n.tags_ru;
  return ((perLang && perLang.length ? perLang : n.tags) || []).filter(Boolean);
}

export function newsSeoTitle(n: NewsItem, locale: Locale): string {
  return (locale === "en" ? n.seo_title_en : n.seo_title_ru) || n.seo_title || "";
}

export function newsSeoDescription(n: NewsItem, locale: Locale): string {
  return (locale === "en" ? n.seo_description_en : n.seo_description_ru) || n.seo_description || "";
}
